import React from 'react'
import styled from 'styled-components'
import moment from 'moment/moment'
import ecbrClock from 'assets/images/icons/ecbr-clock.svg'


const Container = styled.div`
  text-align: center;
  margin-bottom: 20px;
`

const SpanIcon = styled.span`
  mask-image: url(${ecbrClock});
  content: '';
  display: block;
  margin: 0 auto 10px;
  height: 55px;
  width: 55px;
  background-color: #2425aa;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: 50% 50%;
  mask-position: 50% 50%;
`

const FinishPaymentSection = ({ date, ecbrNo }) => {
  const dateString = date ? moment(date).format('D MMMM YYYY') : ''
  const splitterDateString = dateString.split(' ')
  const dateStringYear = splitterDateString[2] ? parseInt(splitterDateString[2]) + 543 + '' : ''

  return (
    <Container>
      <SpanIcon />
      <span className="title-text">กรุณาตรวจสอบใบรับเงินชั่วคราว</span>
      <div>
        เลขที่ {ecbrNo} วันที่ {`${splitterDateString[0]} ${splitterDateString[1]} ${dateStringYear}`}
      </div>
      <div>ระบบดำเนินการส่งออกไปยังอีเมลของท่านเรียบร้อยแล้ว</div>
    </Container>
  )
}

export default (hoc) => hoc(FinishPaymentSection)
